<div class="bg-color-sidebar sticky top-0 shadow-md">
    <div class="flex justify-center py-2">
        @if (!isCollapsed()) {
            <a
                [routerLink]="['/dashboard/home/client']"
                class="flex cursor-pointer items-center">
                <img
                    src="assets/logo/hairstyleclub-full-logo.png"
                    class="h-8 w-auto object-contain md:h-12"
                    alt="Hair Style Club" />
            </a>
        }
        @if (isCollapsed()) {
            <a
                [routerLink]="['/dashboard/home/client']"
                class="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center">
                <img
                    src="assets/logo/hairstyleclub-icon.png"
                    class="aspect-square h-10 w-10 object-contain"
                    alt="Hair Style Club" />
            </a>
        }
    </div>
    <div
        class="flex min-h-[100vh] flex-col justify-between space-y-6 px-2 pb-16">
        <ul class="mt-14 space-y-1 sm:mt-6">
            @for (item of clientNavigationItems; track $index) {
                <li>
                    <a
                        [routerLink]="[item.routerLink]"
                        routerLinkActive="active"
                        #rla="routerLinkActive"
                        class="secondary-text hover:bg-primary-soft text-text-primary flex items-center gap-4 rounded-sm px-4 py-2 font-medium">
                        <span
                            class="pi {{
                                item.icon
                            }} text-xl md:text-2xl font-semibold text-gray-700 secondary-text"
                            routerLinkActive="text-white"
                            [pTooltip]="
                                isCollapsed() ? item.label : undefined
                            "></span>
                        @if (!isCollapsed()) {
                            <span class="font-medium">{{ item.label }}</span>
                        }
                    </a>
                </li>
            }
        </ul>
        <div class="bottom-0">
            <span class="text-xs text-gray-400">Version: {{ version() }}</span>
        </div>
    </div>
</div>
